import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Container, Grid, Header, Icon, Label, Loader, Menu, MenuMenu, Message } from 'semantic-ui-react';

import { crearJornada, fetchJornadas } from "../../api";
import { fijarJornadas, fijarJornadaActiva, limpiar_jornadas } from "../../actions";
import moment from '../../utils/Moment'
import {JORNADAS_DETAIL, REPARTOS} from '../../utils/Routes'
import { permisos_fs } from '../../reducers/SessionReducer';
import { AppHeader } from '../../components';
import Screen from '../Screen';



/* TODO
  - agregar un offset para detectar el final un poco antes
*/
class Jornadas extends Screen {
  state = {
    loading: true,
    mensaje: false,
    current: null,
    //jornadas: [],
    busy: false
  }

  accion = false
  pagina = 0

  componentDidMount() {
    this.props.limpiar_jornadas()
    this.fetch().catch(console.error)
    document.addEventListener('scroll', this.onScroll)
  }

  componentWillUnmount() {
    document.removeEventListener('scroll',  this.onScroll)
  }

  nueva = () => {
    this.startLoading()
    crearJornada().then(res => {
      if (res.status === 'success') {
        this.setState({ mensaje: true })
        this.props.limpiar_jornadas()
        this.pagina = 0
        return this.fetch()
      }
    }).catch(console.error).finally(this.stopLoading)
  }

  fetch = async () => {
    if (this.accion) {
      return
    }
    try {
      this.accion = true
      //console.log('pagina', this.pagina)
      this.setState({ busy: true })
      await this.props.fijarJornadas(this.pagina)
      this.pagina += 1
      //const res = await fetchJornadas(50 * pagina, 50)
      /*this.setState({
        jornadas: [...this.state.jornadas, ...res.data]
      })*/
      await this.props.fijarJornadaActiva()
    } catch (e) {
      console.log(e)
    } finally {
      this.stopLoading()
      this.setState({ busy: false })
      this.accion = false
    }
  }

  detalle = (id) => this.props.history.push(JORNADAS_DETAIL.replace(':id', id))
  
  repartos = (id) => this.props.history.push(REPARTOS)

  onScroll = (e) => {
    //console.log(window.innerHeight, Math.round(window.scrollY), document.body.scrollHeight)
    //console.log(this.accion)
    if (Math.round(window.scrollY) + window.innerHeight >= (document.body.scrollHeight)/* && !this.accion*/) {
      //const pagina = this.state.pagina + 1
      //this.accion = true
      this.fetch()
    }
  }

  render() {
    const { mensaje, busy } = this.state
    const { jornada_activa, operador, jornadas } = this.props
    const actual = jornadas.find(v => v.id === jornada_activa)
    const data = jornadas.filter(v => v.id !== jornada_activa)/*.sort(sortDates)*/

    return (
      <div>
        <AppHeader>
          <Menu.Item>
            <Icon name="balance scale" />
            Jornadas
          </Menu.Item>

          {operador && (
          <MenuMenu position='right'>
            <Menu.Item onClick={this.repartos}>
              <Icon name="motorcycle scale" />
              Repartos
            </Menu.Item>
            <Menu.Item onClick={this.nueva} disabled={jornada_activa !== null}>
              <Icon name="plus" />
              Nueva Jornada
            </Menu.Item>
          </MenuMenu>
          )}
        </AppHeader>
        <Container>
          
          {mensaje && <MensajeNuevaJornada />}
          <Grid divided="vertically" verticalAlign="middle">
            {actual && <Jornada active={true} {...actual} onClick={() => this.detalle(actual.id)} />}
            {data.map(j => (
              <Jornada {...j} key={j.id} onClick={() => this.detalle(j.id)} />
            ))}
          </Grid>
          <Loader active={busy} inline='centered' />
        </Container>
      </div>
    )
  }
}

const MensajeNuevaJornada = () => (
  <Message color="yellow">
    Nueva jornada creada
  </Message>
)

const Jornada = ({ id, active, cierre, apertura, onClick }) => (
  <Grid.Row onClick={onClick} className="cs-pointer">
    <Grid.Column width={4}>
      <Label circular size="big" color={cierre ? 'green' : 'yellow'}>{id}</Label>
    </Grid.Column>
    <Grid.Column width={12}>
      {active &&
        <Header>Jornada Actual</Header>
      }
      <div>
        Creada <strong>{moment(apertura).format("DD/MM/YYYY")}</strong> a las <strong>{moment(apertura).format('H:mm:ss')}</strong>.
        {cierre != null && <Closed cierre={cierre} />}
      </div>
    </Grid.Column>
  </Grid.Row>
)

function sortDates(a, b) {
  return moment(a).isBefore(b) ? -1  : 1
}

function Closed({ cierre }) {
  const fecha = moment(cierre)
  return (
    <div>
      Cerrada el <strong>{fecha.format("DD/MM/YYYY")}</strong> a las <strong>{fecha.format('H:mm:ss')}</strong>
    </div>
  )
}

const mapStateToProps = (state) => ({
  jornadas: state.jornadas,
  jornada_activa:  state.jornada_activa,
  operador: permisos_fs(state) >= 1024
  
})
const mapDispatchToProps = (dispatch) => bindActionCreators({ 
  fijarJornadas,
  fijarJornadaActiva,
  limpiar_jornadas
}, dispatch)

/*const mapDispatchToProps = (dispatch) => ({
  fijarJornadas: (offset) => dispatch(fijarJornadas(offset)),
  fijarJornadaActiva: () => dispatch(fijarJornadaActiva()),
  limpiar_jornadas: () => dispatch(limpiar_jornadas())
})*/

export default connect(mapStateToProps, mapDispatchToProps)(Jornadas)